import { Calendar, TrendingUp, Lock } from 'lucide-react';

const WINIBLE_URL = 'https://www.winible.com/checkout/1547324105701741163?pid=1547324105714324076';

export const PickCardGated = ({ pick }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  // Generate a fake trend indicator for teaser
  const getTrendDirection = () => {
    const random = Math.random();
    if (random > 0.6) return { text: 'Trending Up', color: 'text-green-500' };
    if (random > 0.3) return { text: 'Stable', color: 'text-yellow-500' };
    return { text: 'Watch Closely', color: 'text-orange-500' };
  };

  const trend = getTrendDirection();

  return (
    <div
      className="bg-card border border-border relative overflow-hidden"
      data-testid={`pick-card-gated-${pick.id}`}
    >
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <span className="font-mono text-xs uppercase tracking-widest text-primary">{pick.sport}</span>
          <div className="flex items-center gap-2 font-mono text-xs text-muted-foreground">
            <Calendar size={12} />
            {formatDate(pick.pick_date)}
          </div>
        </div>

        {/* Player & Prop (Visible) */}
        <h3 className="font-heading font-bold text-xl mb-3">
          {pick.player_name} – {pick.prop_type}
        </h3>

        {/* Teaser Stats */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center gap-2">
            <TrendingUp size={14} className={trend.color} />
            <span className={`font-mono text-sm ${trend.color}`}>{trend.text}</span>
          </div>
        </div>

        {/* Blurred/Locked Section */}
        <div className="relative">
          <div className="blur-sm select-none pointer-events-none">
            <p className="text-muted-foreground text-sm mb-2">
              <span className="font-mono font-bold">LINE:</span> ██.█
            </p>
            <p className="text-foreground font-bold text-sm mb-2">
              <span className="font-mono">PICK:</span> ████
            </p>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Full analysis includes matchup context, historical performance data, and confidence breakdown...
            </p>
          </div>
          
          {/* Lock Overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-card/80">
            <Lock className="text-primary mb-2" size={24} />
            <p className="text-xs text-muted-foreground text-center mb-3 px-4">
              Full analysis available to subscribers
            </p>
            <a
              href={WINIBLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary hover:bg-primary/90 text-white text-sm font-bold px-4 py-2 rounded transition-all hover:scale-105"
            >
              Unlock Full Breakdown
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
